import api from "@services/axiosInstance";

function getTopScored() {
  return api.get("/mix/topscored");
}

export default {
  getTopScored,
};
